
// => Styling
import styles from './SettingsView.module.css';

// => Icons
import { 
    IoReturnDownBack,
    IoCheckmark,
    IoClose,
    IoHeartOutline,
 } from "react-icons/io5";

 // => Svgs
 import brand_new from '../../content/brand_new.svg';

// => Content
import tags from '../../content/tags.json';
import { prefs } from '../../preferences';

// => Components
import TagToggle from './components/TagToggle';
import Modal from '../../components/Modal';
import Dialog from '../../components/Dialog';

// => Views
import HtmlPngEditorView from '../dev/HtmlPngEditorView';

// => React
import { useState } from 'react';


// ============
// Component
// ============
const SettingsView = ({
    requestClose,
    lastSaveTime = null,
    onResetSave = () => {},
    debugEnabled = false,
}) => {

    const defaults = {
        exclude: [
            "shemale",
        ],
        only: [],
    }
    const [tagSettings, setTagSettings] = useState(prefs.getPref(prefs.PREF_TAGS, defaults))

    const onChangeTagSetting = (tag, value) => {

        function removeTag(list = [], tagName) {
            let r = list
            let i = r.indexOf(tagName)
            if (i >= 0 && i < r.length) r.splice(i, 1)
            return r
        }
        function addTag(list = [], tagName) {
            let r = list
            if (r.filter((a) => a === tagName).length === 0) {
                r.push(tagName)
            }
            return r
        }

        //console.log("onChangeTagSetting", tag, value)
        let result = tagSettings

        switch(value) {
            case "exclude":
                result.only = removeTag(result.only, tag)
                result.exclude = addTag(result.exclude, tag)
                break;
            case "none":
                result.only = removeTag(result.only, tag)
                result.exclude = removeTag(result.exclude, tag)
                break;
            case "only":
                result.only = addTag(result.only, tag)
                result.exclude = removeTag(result.exclude, tag)
                break;
            default:
                result.only = removeTag(result.only, tag)
                result.exclude = removeTag(result.exclude, tag)
                break;
        }
        
        //console.log("result", result)
        setTagSettings(result)
        prefs.setPref(prefs.PREF_TAGS, JSON.stringify(result))
    }

    const getTagValue = (tagSettings = defaults, tag) => {
        
        // Exclude
        if (tagSettings.exclude.filter((a) => a === tag).length !== 0) {
            return "exclude"
        } else if (tagSettings.only.filter((a) => a === tag).length !== 0) {
            return "only"
        } else {
            //let defaultValue = "none"
            /*
            let tagsCombined = tags.babes.concat(tags.cocks)
            let findTag = tagsCombined.find((e) => e.id === tag)
            if (findTag) {
                defaultValue = findTag.defaultValue
            }*/
            /*
            let babe = tags.babes.find((e) => e.id === tag)
            let cock = tags.cocks.find((e) => e.id === tag)
            if (babe !== undefined) {
                defaultValue = babe.defaultValue
            } else if (cock !== undefined) {
                defaultValue = cock.defaultValue
            }
            */

            //return defaultValue
            return "none"
        }
    }

    const [modalResetSave, setModalResetSave] = useState(false)
    const confirmResetSave = () => {
        onResetSave()
    }
    const cancelResetSave = () => {
        setModalResetSave(false)
    }


    /* DEVELOPER DEVELOPER DEVELOPER */
    const [modalDevHtmlPngEditor, setModalDevHtmlPngEditor] = useState(false)


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            <button className={styles.closeButton} onClick={requestClose}><IoReturnDownBack size="36px"/></button>
            
            <div className={styles.settings}>

                <span className={styles.title}><img className={styles.brandImg} src={brand_new} alt='Cock Roulette' /></span>
                <div style={{height: '0.4em'}}/>
                <div className={styles.tagInfo}>
                    <span><b>Version 0.4.1</b> | 2024/09/29</span>{debugEnabled ? "{ DEBUG MODE }" : ""}
                    <span><img className={styles.devImg} src="assets/img/placeholder/digitalhedonist.png" alt=''/> by <b>Digital Hedonist Games</b> (aereton)</span>
                    <span>digital-hedonist [@] proton.me</span>
                    <span style={{fontSize: '6pt', fontWeight: 'normal'}}><i>All video content pulled from publicly available internet sources (i.e. Reddit). If you believe you are depicted and want your likeness removed, contact me with a description of the offending content.</i></span>
                </div>
                <div className={styles.section}>
                    Join the community:
                    <div className={styles.sectionContent}>
                        <a href="https://discord.gg/v62AZf522y" rel="noreferrer" target='_blank'><img className={styles.f95logo} src="assets/img/discord-logo-blue.png" alt='' /></a>
                        <a href="https://f95zone.to/threads/216205/" rel='noreferrer' target='_blank'><img className={styles.f95logo} src="assets/img/f95-logo.png" alt='' /></a>
                    </div>
                </div>

                {/* DEV OPTIONS */}
                {debugEnabled && (
                    <>
                        <span className={styles.title}>Dev Options</span>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>Tools</div>
                            <div className={styles.sectionContent}>
                                <button className={[styles.saveBtn, styles.primaryBtn].join(" ")}
                                        onClick={()=>setModalDevHtmlPngEditor(true)}>HTML2PNG editor </button>
                            </div>
                        </div>
                        <div style={{height: '1em'}}></div>
                    </>
                )}
                

                {/* SAVE DATA */}
                <span className={styles.title}>Save Data</span>
                <div className={styles.tagInfo}><span>Last saved: <b>{lastSaveTime ? lastSaveTime.toUTCString() : "none"}</b></span></div>
                <div className={styles.section}>
                    <div className={styles.sectionContent}>
                        <button onClick={()=>setModalResetSave(true)} className={[styles.saveBtn, styles.primaryBtn].join(" ")}>Reset</button>
                        <button disabled className={[styles.saveBtn, styles.secondaryBtn].join(" ")}>Export Save</button>
                        <button disabled className={[styles.saveBtn, styles.secondaryBtn].join(" ")}>Import Save</button>
                    </div>
                </div>

                {/*<div style={{height: '1em'}}></div>*/}
                {/* SYSTEM SETTINGS */}
                {/*<span className={styles.title}>System Settings</span>
                <div className={styles.tagInfo}>Change settings to improve system performance or behaviour.</div>
                <div className={styles.section}>
                    <div>
                        <input type="checkbox" id="check_sysSetting_cardVideo" />
                        <label htmlFor="check_sysSetting_cardVideo">sdfsdf</label>
                    </div>
                </div>*/}

                <div style={{height: '1em'}}></div>
                {/* CONTENT TAGS */}
                <span className={styles.title}>Content Tags</span>
                <div className={styles.tagInfo}>
                    Customize which video clips will be shown. Some tags can be shown exclusively, hiding all content that doesn't include the tag.
                    <span><b>Attention:</b> This can drastically reduce the amount of clips available!</span>
                </div>
                <div className={styles.section}>
                    <span className={styles.sectionTitle}>Babes</span>
                    <div className={styles.sectionContent}>
                        {tags.babes.map((e) =>
                            <TagToggle key={e.name + e.id} name={e.id} label={e.name} allowSetOnly={e.allowSetOnly} desc={e.desc} onChange={onChangeTagSetting} startValue={getTagValue(tagSettings, e.id)} />
                        )}
                    </div>
                </div>
                <div className={styles.section}>
                    <span className={styles.sectionTitle}>Cocks</span>
                    <div className={styles.sectionContent}>
                        {tags.cocks.map((e) =>
                            <TagToggle key={e.name + e.id} name={e.id} label={e.name} allowSetOnly={e.allowSetOnly} desc={e.desc} onChange={onChangeTagSetting} startValue={getTagValue(tagSettings, e.id)} />
                        )}
                    </div>
                </div>

            </div>

            {modalResetSave && <Modal>
                <Dialog title='Reset save data?'
                        msg={<span>This action will <b>reset ALL saved data</b> and restart the game. Are you sure?</span>}
                        onConfirm={confirmResetSave}
                        onCancel={cancelResetSave} />
            </Modal>}

            {/* DEVELOPER VIEWS */}
            {modalDevHtmlPngEditor && <Modal>
                <HtmlPngEditorView requestCloseEditor={()=>setModalDevHtmlPngEditor(false)}/>
            </Modal>}
        </div>
    );
}


export default SettingsView